import { render, staticRenderFns } from "./SelectOptionStudents.vue?vue&type=template&id=134d3adc&scoped=true"
import script from "./SelectOptionStudents.vue?vue&type=script&lang=js"
export * from "./SelectOptionStudents.vue?vue&type=script&lang=js"
import style0 from "./SelectOptionStudents.vue?vue&type=style&index=0&id=134d3adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d3adc",
  null
  
)

export default component.exports